module.exports = __webpack_public_path__ + "static/media/fondo-login-xpdconnect.d4d3b216.jpg";